import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'wouter';
import { useEffect } from 'react';
import { api } from './api.js';
import { ApiHttpError } from './query.js';

export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: api.me,
    retry: false,
  });
}

export function useRequireAuth() {
  const me = useMe();
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (me.isError && me.error instanceof ApiHttpError && me.error.status === 401) {
      setLocation(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
    }
  }, [me.isError, me.error, setLocation]);

  return me;
}
